import { Modal, Select } from "antd";
import { ListFilter } from "lucide-react";
import React, { useEffect, useState } from "react";
import { getAssignedBatchData } from "../../../../../api/org-admin";
import WebUtils from "../../../../../utils/WebUtils";
import Utils from "../../../../../utils/Utils";

function FilterMockModal({
  setMockFilterFlag,
  mockFilterFlag,
  setInterviewState,
  interviewState,
  batchIdsFilter,
  setBatchIdsFilter,
  iDronaId,
  setLoading,
}) {
  const userDetail = Utils.getUserDetail();
  const [tempFilter, setTempFilter] = useState({
    interviewState: interviewState,
    batch: batchIdsFilter,
  });
  const [batchIdData, setBatchIdData] = useState(null);
  const getBatch = () => {
    const url = `${getAssignedBatchData}?organizationId=${
      userDetail?.organizationId || null
    }&iDronaInterviewConfigurationId=${iDronaId}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   console.log(result.data.data);
          let data = result?.data?.data;
          setBatchIdData(data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const interviewStateItem = [
    {
      value: "ALL",
      label: "All",
    },
    {
      value: "CONFIGURED",
      label: "Configured",
    },
    {
      value: "INTERVIEW_SCHEDULED",
      label: "Interview Scheduled ",
    },
    {
      value: "INTERVIEW_COMPLETED",
      label: "Interview Completed ",
    },
    {
      value: "INTERVIEW_EXPIRED",
      label: "Interview Expired",
    },
  ];

  const handleSubmit = () => {
    setInterviewState(tempFilter.interviewState);
    setBatchIdsFilter(tempFilter.batch);
    setMockFilterFlag(false);
  };

  const batchOptions = Array.from(
    new Map([
      ...(batchIdData || []).map((item) => [
        item.batchIdentifier,
        {
          label: (
            <div>
              <p className="font-medium mb-0">
                {item.batchName}{" "}
                <span className="text-[.75rem] text-gray-500">
                  ({item.batchIdentifier})
                </span>
              </p>

              <p className="text-[.75rem] text-gray-500 mb-0">
                Created on{" "}
                {new Date(item.assignedDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            </div>
          ),

          value: item.batchIdentifier,
          title: item.batchName,
        },
      ]),
    ]).values(),
  );

  useEffect(() => {
    getBatch();
  }, []);
  return (
    <Modal
      open={mockFilterFlag}
      onCancel={() => setMockFilterFlag(false)}
      footer={null}
      centered
      width={550}
      title={
        <div className="flex items-center gap-1 text-[1rem]">
          <ListFilter size={18} />
          <span>Filter</span>
        </div>
      }
    >
      <div className="mt-5">
        <p>Select interview state</p>
        <Select
          // allowClear
          className="w-full mt-1"
          size="large"
          placeholder="Select interview state"
          value={tempFilter.interviewState}
          onChange={(value) => {
            // console.log(value);
            setTempFilter((prev) => ({
              ...prev,
              interviewState: value,
            }));
          }}
          options={interviewStateItem}
        />
      </div>
      <div className="mt-5">
        <p>Select batch IDs</p>
        <Select
          mode="multiple"
          allowClear
          className="w-full mt-1"
          size="large"
          placeholder="Select batch IDs"
          value={tempFilter.batch}
          onChange={(value) => {
            // console.log(value);
            setTempFilter((prev) => ({
              ...prev,
              batch: value,
            }));
          }}
          options={batchOptions}
          maxTagCount="responsive"
          optionLabelProp="title"
        />
      </div>

      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setMockFilterFlag(false)}
        >
          Cancel
        </button>

        <button
          //   disabled={selectedBatchGuides?.length < 1}
          onClick={handleSubmit}
          className={` btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Apply filter
        </button>
      </div>
    </Modal>
  );
}

export default FilterMockModal;
